<template lang="pug">
v-breadcrumbs(v-if="breadcrumbs.length").pb-0.pt-1.px-0
  v-breadcrumbs-item.opacity-5.home-link
    v-icon.mr-1 mdi-home
  li.v-breadcrumbs__divider.opacity-5.px-2.text-muted 
    <i class="mdi mdi-chevron-right"></i>
  template(v-if="breadcrumbs.length > 0")
    template(v-for="(item, index) in breadcrumbs")
      v-breadcrumbs-item(
        v-if="item.route"
        :key="`item-${index}`"
        @click="navigateTo(item.route)"
      ).opacity-5.cursor-pointer.hover-text
        template {{ $t(item.title) }}
      v-breadcrumbs-item(
        v-else
        :key="`item-${index}`"
      ).text-dark
        template {{ $t(item.title) }}
      li(
        v-if="index < breadcrumbs.length - 1"
        :key="`divider-${index}`"
      ).v-breadcrumbs__divider.opacity-5.px-2.text-muted 
        <i class="mdi mdi-chevron-right"></i>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AppBreadcrumbs',
  computed: {
    ...mapGetters('breadcrumbs', ['breadcrumbs'])
  },
  methods: {
    navigateTo(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style>
.hover-text{
  transition: all 0.3s ease;
}
.hover-text:hover {
  color: #3177f0 !important;
  opacity: 1 !important;
}
</style>
